import { handleMessages, load } from './util';

$(document).on('submit', '[data-checkout-form]', (event) => {
  const $confirmMessages = $('[data-checkout-confirm-messages]');
  if ($confirmMessages.length) {
    event.preventDefault();
    $confirmMessages.foundation('open');
  } else {
    $('[data-checkout-form] button[type="submit"], button[type="submit"][form="checkout-form"]').each(function() {
      this.disabled = true;
    });
  }
});

$(document).on('click', '[data-checkout-edit]', function(event) {
  event.preventDefault();
  const $this = $(this);

  if ($this.is('.disabled')) {
    return;
  }
  const $widget = $this.closest('[data-checkout-step]');
  load(
    $widget,
    $.stores.checkout.load($this.attr('href')),
  );
});

$(document).on('click', '[data-checkout-abort]', function(event) {
  event.preventDefault();
  const $widget = $(this).closest('[data-checkout-step]');
  load(
    $widget,
    $.stores.checkout.load($(this).attr('href')),
  );
});

$(document).on('submit', '[data-checkout-update-form]', function(event) {
  event.preventDefault();
  if (this.disabled) {
    return;
  }

  const $form = $(this);
  const $widget = $form.closest('[data-checkout-step]');
  load(
    $widget,
    $.stores.checkout.load($form.attr('action'), $form.serialize()),
  );
  this.disabled = true;
});

$(document).on('change', '[data-payment-method-input]', function() {
  $(`#${$(this).attr('data-payment-method-input')}`).val($(this).attr('data-payment-method'));
});

$(document).on('change', '[data-payment-term-input]', function() {
  $(`#${$(this).attr('data-payment-term-input')}`).val($(this).attr('data-payment-term'));
});

$(document).on('click', '[data-checkout-address-edit]', function(event) {
  event.preventDefault();
  const $content = $(this).closest('.widget__content');
  $.ajax({
    url: $(this).attr('href'),
    method: 'GET',
  }).then(handleMessages).then((data) => {
    $content.replaceWith(data);
  });
});

$(document).on('click', '[data-billing-like-shipping]', function() {
  const $this = $(this);
  const addr = $this.attr('data-billing-like-shipping') || 'billing';
  const disabled = $this.is(':checked');
  const required = !disabled;

  // Depending on billing-like-shipping the address inputs
  // have to be disabled respectively required
  $this.closest('form')
    .find(`input[name^="${addr}_"],select[name^="${addr}_"]`)
    .not(this)
    .prop('disabled', disabled)
    .removeAttr('data-invalid')
    .removeClass('is-invalid-input')
    .not(`[name="${addr}_salutation"], [name="${addr}_name2"], [name="${addr}_street2"], [name="${addr}_country"]`)
    .prop('required', required);
  $this.closest('form')
    .find(`label[for^="id_${addr}_"]`)
    .removeClass('is-invalid-label');
});

$(document).on('click', '[data-object-target="checkout"][data-object-set]', function (event) {
  event.preventDefault();
  $('#id_customer_object').val($(this).attr('data-object-set')).trigger('change');
  $('#id_customer_object_text').html($(this).attr('data-object-text'));
  $(this).closest('[data-reveal]').foundation('close');
});

$(document).on('click', '[data-object-target="checkout"][data-object-reset]', (event) => {
  event.preventDefault();
  $('#id_customer_object').val('').trigger('change');
  $('#id_customer_object_text').html('----------');
});

$(document).on('change', '#id_customer_object', function() {
  $('[data-object-target="checkout"][data-object-reset]').toggleClass('hide', !$(this).val());
});

$(document).on('click', '[data-checkout-confirm-message-confirm]', function() {
  const currentMessage = $(this).closest('[data-checkout-confirm-message]');
  const nextMessage = currentMessage.next('[data-checkout-confirm-message]');
  const reveal = currentMessage.closest('[data-reveal]').addClass('loading');
  if (nextMessage.length) {
    setTimeout(() => {
      currentMessage.addClass('hide');
      nextMessage.removeClass('hide');
      reveal.removeClass('loading');
    }, 250);
  } else {
    reveal.removeAttr('data-checkout-confirm-messages');
    $('[data-checkout-form]').submit();
  }
});

$(document).on('click', '[data-checkout-confirm-message-abort][data-checkout-edit]', function() {
  $(this).closest('[data-reveal]').addClass('loading');
  $.stores.checkout.load($(this).attr('href'));
});

$(document).on('change', '#id_accept_terms', function() {
  $.stores.checkout.setTermsAccepted(this.checked);
});
